import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import { addProductRequest, addProductRequestError, addProductRequestSuccess } from '../../slices/Product/AddProductSlice';

export const AddProductAPI = (data) => {
    return async (dispatch) => {
        try {
            dispatch(addProductRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.addProduct,
                data: data,
            })
            return dispatch(addProductRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(addProductRequestError(_error));
        }
    };
};
